import { memo } from 'react';

import { AuthTokensRefreshProvider } from './contexts/AuthTokensRefreshContext';
import { useAuthManagement } from './hooks/useAuthManagement';
import { AuthContextProps } from './types/AuthContextProps';
import { AuthApiContext } from './AuthApiContext';
import { AuthDataContext } from './AuthDataContext';

const AuthProviderComponent = ({ children }: AuthContextProps) => {
  const { api, data } = useAuthManagement();

  return (
    <AuthApiContext.Provider value={api}>
      <AuthDataContext.Provider value={data}>
        <AuthTokensRefreshProvider>{children}</AuthTokensRefreshProvider>
      </AuthDataContext.Provider>
    </AuthApiContext.Provider>
  );
};

export const AuthProvider = memo(AuthProviderComponent);
